var exports = {
  "kL": "CompactVoiceCallView.module__container___eVlXTE",
  "gw": "CompactVoiceCallView.module__containerNoHeader___eVlXTE",
  "lf": "CompactVoiceCallView.module__containerReserveHeaderChrome___eVlXTE",
  "L7": "CompactVoiceCallView.module__containerNoControlBar___eVlXTE",
  "ap": "CompactVoiceCallView.module__containerFillHeight___eVlXTE",
  "tZ": "CompactVoiceCallView.module__contentArea___eVlXTE",
  "$7": "CompactVoiceCallView.module__contentAreaAudioOnly___eVlXTE",
  "OZ": "CompactVoiceCallView.module__audioAvatarLayout___eVlXTE",
  "a3": "CompactVoiceCallView.module__audioAvatarLayoutInner___eVlXTE",
  "d6": "CompactVoiceCallView.module__audioAvatarLayoutFullBleed___eVlXTE",
  "nd": "CompactVoiceCallView.module__audioAvatarLayoutInnerFullBleed___eVlXTE",
  "Gq": "CompactVoiceCallView.module__audioAvatarList___eVlXTE",
  "D9": "CompactVoiceCallView.module__layoutHost___eVlXTE",
  "pl": "CompactVoiceCallView.module__layoutHostFullHeight___eVlXTE",
  "DO": "CompactVoiceCallView.module__layoutHostFullHeightGrid___eVlXTE",
  "vR": "CompactVoiceCallView.module__layoutHostFullHeightFocus___eVlXTE",
  "_t": "CompactVoiceCallView.module__controlBarSection___eVlXTE",
  "Vw": "CompactVoiceCallView.module__controlBarInner___eVlXTE",
  "AD": "CompactVoiceCallView.module__fullscreenButtonWrap___eVlXTE",
  "I": "CompactVoiceCallView.module__heightToggleButtonWrap___eVlXTE",
  "Ip": "CompactVoiceCallView.module__heightToggleButtonShell___eVlXTE",
  "x8": "CompactVoiceCallView.module__heightTogglePill___eVlXTE",
  "_A": "CompactVoiceCallView.module__heightTogglePillIcon___eVlXTE",
  "oP": "CompactVoiceCallView.module__heightToggleUnreadBadge___eVlXTE",
  "Di": "CompactVoiceCallView.module__resizeHandle___eVlXTE",
  "YC": "CompactVoiceCallView.module__resizePill___eVlXTE",
  "$I": "CompactVoiceCallView.module__containerResizing___eVlXTE",
};

module.exports = exports;
